import { render, staticRenderFns } from "./routerView.vue?vue&type=template&id=4ff3a534&scoped=true&"
import script from "./routerView.vue?vue&type=script&lang=js&"
export * from "./routerView.vue?vue&type=script&lang=js&"
import style0 from "./routerView.vue?vue&type=style&index=0&id=4ff3a534&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff3a534",
  null
  
)

export default component.exports